<div class="flex justify-content-center align-items-center h-12">
  <p-blockUI [blocked]="isLoading">
    <div id="center">
      <p-progressSpinner [style]="{ width: '100px', height: '200px' }" strokeWidth="6"></p-progressSpinner>
    </div>
  </p-blockUI>
</div>

<div class="flex flex-column justify-content-between md:flex-column">
  <div class="flex w-full">
    <div class="col-8">
      <h4 class="p-2" *ngIf="plate !== null">
          Plate Information: <strong>{{ plate?.plateID }} <span *ngIf="checkIfPlateIsBlocked()" class="pi pi-exclamation-circle" tooltipPosition="right" tooltipZIndex="10000" pTooltip="Plate has been blocked."></span></strong>
      </h4>
    </div>
    <div class="col-4 flex justify-content-end" *ngIf="plate !== null">
      <button pButton class="w-15rem action-button h-2rem md:text-sm text-primary px-0" type="button" id="plateView"
        [label]="plateViewButtonLabel" (click)="getSearchPlateInfo()"></button>
    </div>
  </div>
  <div class="flex flex-column" *ngIf="plate !== null">
    <p-panel header="Plate Metadata" class="p-2" [toggleable]="true">
      <p-table [value]="plate | keyvalue" [scrollable]="true" scrollHeight="80vh" styleClass="p-datatable-striped p-1 md:text-sm lg:text-md">
        <ng-template pTemplate="header">
          <tr>
            <th scope="col">Property</th>
            <th scope="col">Value</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-fields>
          <tr *ngIf="checkIfValidState(fields)">
            <td>{{ fields.key }}</td>
            <td>{{ requiresFormatting(fields) }}</td>
          </tr>
        </ng-template>
      </p-table>
      <div class="flex gap-3 justify-content-between lg:flex-column">
        <button pButton class="w-15rem action-button h-2rem md:text-sm text-primary px-0" type="button" (click)="emitDownloadEvent()" label="Download Excel"></button>
        <button pButton class="w-15rem action-button h-2rem md:text-sm text-primary px-0" type="button" (click)="showBatchComment = true" label="Batch Comments"></button>
      </div>
    </p-panel>
  </div>
  <div class="flex flex-column" *ngIf="plateProcessSteps?.length !== 0">
    <p-panel header="Plate Process Data" [toggleable]="true" class="p-2">
      <div class="p-2 flex w-full justify-content-end">
        <div *ngIf="isSuperUserOrAdmin || checkIfPlateIsBlocked()">
          <button pButton class="w-15rem md:w-12rem sm:w-full start-button h-2rem sm:text-sm md:text-sm hover:start-button text-primary m-1" type="button" (click)="openRedoDialog()" label="Redo Plate"></button>
          <button pButton class="w-15rem md:w-12rem sm:w-full complete-button h-2rem sm:text-sm md:text-sm hover:start-button text-primary m-1" type="button" (click)="openStatusDialog()" label="Status Change"></button>
          <button pButton class="w-15rem md:w-12rem sm:w-full action-button h-2rem sm:text-sm md:text-sm hover:start-button text-primary m-1" type="button" (click)="openSampleTypeDialog()" label="Sample Type Change"></button>
        </div>
      </div>
      <p-table [value]="plateProcessSteps" styleClass="p-datatable-striped md:text-sm lg:text-md" [scrollable]="true" scrollHeight="80vh">
        <ng-template pTemplate="header">
          <tr>
            <th scope="col">Batch ID</th>
            <th scope="col">Step Action</th>
            <th scope="col">PUID</th>
            <th scope="col">Time</th>
            <th scope="col">Equipment</th>
            <th scope="col">Reagents</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-step>
          <tr>
              <td>
                  <div>{{ step.plateId }}</div>
                  <div *ngIf="step.batchID">({{ step.batchID }})</div>
              </td>
            <td>
              <div *ngFor="let action of step.stepAction.split(',')">
                {{ action }}
              </div>
            </td>
            <td>{{ step.puid }}</td>
            <td>{{ step.stepTime }}</td>
            <td>
              <div *ngFor="let equipment of step.equipment">
                {{ equipment.machineType }} : {{ equipment.machineBarcodes }}
              </div>
            </td>
            <td>
              <div *ngFor="let chem of step.reagents">
                {{ chem.chemical }} : {{ chem.lots }}
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-panel>
  </div>
</div>

<p-dialog #qcDialog [(visible)]="redoDialog" header="Redo Plate" class="bg-primary button-dialog" styleClass="lg:w-5 md:w-10 min-w-min"
    position="top" [modal]="true" [dismissableMask]="true" (onHide)="closeDialog()">
    <app-multiplate-qc [selectedProtocol]="selectedProtocol" [historyDialogDTO]="historyDialogDTO"
        [selectedProjectWorkflow]="plateWorkflow" [selectedProject]="selectedProject" [workflowMap]="workflowMap" [projectMap]="projectMap"
        (platesUpdatedEmitter)="searchPlate(searchInput)" (closeDialogEmitter)="closeDialog()">
    </app-multiplate-qc>
</p-dialog>

<p-dialog header="Status Update" [(visible)]="statusDialog" [modal]="true" [draggable]="false" (onHide)="closeDialog()" [resizable]="false">
  <div class="flex flex-column align-items-center">
    <div class="flex flex-column p-2 w-full">
      <h5 class="text-md p-1 sm:text-md lg:text-lg">
        Status change for : <strong>{{ plate?.lastUpdatedPlateID }}</strong>
      </h5>
    </div>
    <div class="flex flex-column justify-content-start w-full">
      <div class="flex flex-column justify-content-start align-items-center md:justify-content-between lg:justify-content-between md:flex-row lg:flex-row">
        <span class="text-primary w-full">Select an status: </span>
        <p-dropdown class="p-1 w-full" [options]="dropDownStatusListOptions" (onChange)="checkIfPlateIsBatchedAndBeingBlocked()" [(ngModel)]="selectedStatusOption" placeholder="Select status" optionLabel="label" [showClear]="true" optionValue="value" [autoDisplayFirst]="false" appendTo="body">
        </p-dropdown>
      </div>
      <div class="flex flex-column justify-content-start align-items-center md:justify-content-between lg:justify-content-between md:flex-row lg:flex-row">
        <span class="text-primary w-full">Select an ID: </span>
        <p-dropdown class="p-1 w-full" [options]="dropDownPlateIDOptions" [(ngModel)]="selectedPlateIDOption" placeholder="Select plate ID" [showClear]="true" [autoDisplayFirst]="false" optionLabel="label" optionValue="value" appendTo="body">
        </p-dropdown>
      </div>
      <div *ngIf="checkIfBatchIdPresent() && !BLOCK_PLATE_STATUES.includes(selectedStatusOption)" class="flex mt-5 mb-1">
        <p-checkbox [(ngModel)]="deletePlateFromBatch" [binary]="true"></p-checkbox>
        <div class="text-primary font-bold ml-1">Remove Plate from Batch</div>
      </div>

    </div>
    <div class="p-2 w-full" *ngIf="selectedPlateIDOption && selectedStatusOption">
      <p-divider class="w-full" align="center">
        <span class="font-bold">Preview</span>
      </p-divider>
      <div class="flex flex-column w-full justify-content-start align-items-center">
        <div class="flex justify-content-start w-full">
          <span class="text-md lg:textlg">PlateID:<strong class="text-primary">{{plate[selectedPlateIDOption.key]}}</strong>
            <br />
            <del class="text-sm"> ({{ plate?.lastUpdatedPlateID }}) </del></span>
        </div>
        <div class="flex justify-content-start w-full">
          <span class="text-md lg:textlg">Status:<strong class="text-primary">{{selectedStatusOption}}</strong>
            <br />
            <del class="text-sm"> ({{ plate?.status }}) </del>
          </span>
        </div>
        <div *ngIf="deletePlateFromBatch; else statusUpdateMessage" class="flex justify-content-start w-full mt-3">
          <span class="font-bold">Plate will be removed from the Batch {{ searchedPlateMap[plate?.plateID]?.batchID }}</span>
        </div>
        <ng-template #statusUpdateMessage>
          <div *ngIf="checkIfBatchIdPresent()" class="flex justify-content-start w-full mt-3">
            <span class="font-bold">Entire Batch {{ searchedPlateMap[plate?.plateID]?.batchID }} will be updated with new status!</span>
          </div>
        </ng-template>
        <div class="flex justify-content-end pt-2 w-full">
          <button pButton class="w-10rem lg:w-15rem complete-button h-2rem md:text-sm hover:start-button text-primary px-0" type="button" (click)="updatePlateStatus()" label="Status change"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog header="Sample Type Update" [(visible)]="sampleTypeDialog" [modal]="true" (onHide)="closeDialog()" [draggable]="false" [resizable]="false">
  <div class="flex flex-column align-items-center">
    <div class="flex flex-column w-full p-2 gap-2">
      <h5 class="text-md p-2 sm:text-md lg:text-lg">
        Sample type change for: <strong>{{ plate?.lastUpdatedPlateID }}</strong>
      </h5>
      <div class="flex gap-2 w-full align-items-center justify-content-between">
        <p-dropdown class="p-2" [options]="dropDownSampleTypeOptions" [(ngModel)]="selectedSampleTypeOption" [showClear]="true" placeholder="Sample types" optionValue="value" [autoDisplayFirst]="false" appendTo=></p-dropdown>
        <button pButton [disabled]="selectedSampleTypeOption === undefined" class="w-12rem lg:w-15rem action-button h-2rem md:text-sm hover:action-button text-primary px-0" type="button" (click)="updatePlateProcessFlowBasedOnSampleType()" label="Sample type change"></button>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog header="{{ getCommentsDialogHeader() }}" [(visible)]="showBatchComment" [maximizable]="true" [modal]="true" [style]="{ 'width': '50vw', 'height': '65vh' }" (onHide)="showBatchComment" [breakpoints]="{'960px':'75vw','648px':'85vw'}">
  <app-comment *ngIf="plate !== null"  [selectedLabID]="selectedLabID" [plateStatus]="plate?.status" [puid]="puid" [displayDialog]="showBatchComment" [plateID]="plate?.plateID"
      [showPlateComment]="true" (onCommentClosed)="showBatchComment = false">
  </app-comment>
</p-dialog>

<p-dialog [(visible)]="showPopupWithMultipleSourcePlates" header="{{ popupHeader }}" class="bg-primary button-dialog" styleClass="w-4 min-w-min"
          position="top" [modal]="true" [baseZIndex]="1000">
  <div>
    <p-table [value]="sourcePlateLists" [scrollable]="true" scrollHeight="100vh"
             styleClass="p-datatable-striped mt-3 mx-1 md:text-sm lg:text-md">
        <ng-template pTemplate="header">
            <tr>
                <th scope="col" class="text-center">{{ selectedPlateHeader }}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-plate>
            <tr>
                <td class="text-center cursor-pointer hover:text-cyan-800" (click)="onPlateSelect(plate)">{{ plate.plateID }}</td>
            </tr>
        </ng-template>
    </p-table>
  </div>
</p-dialog>
